import { render, staticRenderFns } from "./DateHeader.vue?vue&type=template&id=09644ac9&scoped=true&"
import script from "./DateHeader.vue?vue&type=script&lang=js&"
export * from "./DateHeader.vue?vue&type=script&lang=js&"
import style0 from "./DateHeader.vue?vue&type=style&index=0&id=09644ac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09644ac9",
  null
  
)

export default component.exports